import { useEffect } from "react";

const AppLock = () => {
  useEffect(() => {
    const channel = new BroadcastChannel("app-lock");

    channel.postMessage("opened");

    channel.onmessage = (e) => {
      if (e.data === "opened") {
        window.location.href = 'https://inua.com.ua/already-opened-judge'
      }
    };

    return () => {
      channel.close();
    };
  }, []);

  return null;
};

export default AppLock;
